import {gsap} from "gsap";
import {throttle} from "lodash/function";

let tween_marquee = null;
let throttle_handler = null;
let windowWidth;

/**
 * Return the parents div for the projects list
 * @returns {Element}
 */
const get_marquee_el = (container) => container.querySelector('section#marquee_section');

/**
 * Duplicate the content inside div_wrapper_el
 * @param div_wrapper_el
 */
const duplicate_content = (div_wrapper_el) => {
    const clone =  div_wrapper_el.firstElementChild.cloneNode(true);
    div_wrapper_el.firstElementChild.after(clone);
}

const resizeHandler = (div_wrapper_el) => {
    // console.log("resize marquee");
    if(window.innerWidth !== windowWidth && tween_marquee !== null){
        windowWidth =window.innerWidth;
        tween_marquee.seek(0);
        tween_marquee.kill();
        create_marquee_tween(div_wrapper_el)
    }
}

const add_resize_listener = (div_wrapper_el) => {
    throttle_handler = throttle(resizeHandler.bind(this, div_wrapper_el), 100);
    window.addEventListener("resize", throttle_handler);
}

/**
 * Create slide left tween
 * @param div_wrapper_el
 */
const create_marquee_tween = (div_wrapper_el) => {
    // console.log("  -> create_marquee_tween");
    const width_div = div_wrapper_el.getBoundingClientRect().width,
        velocity = 16, // 74 px/s
        tween_duration = width_div/window.innerWidth*velocity*.5;
    tween_marquee  = gsap.to(div_wrapper_el, {x:"-50%", duration:tween_duration,repeat:-1, ease: "none"});
}


const init_marques = (container) => {
    const elem = get_marquee_el(container);
    if( elem ){
        const div_inside = elem.querySelector("div");
        duplicate_content(div_inside);
        create_marquee_tween(div_inside);
        add_resize_listener(div_inside);
    }
}

const desinit_marques = (container) => {
    const elem = get_marquee_el(container);
    if( elem ){
        // console.log("desinit marquee");
        window.removeEventListener("resize", throttle_handler);
        tween_marquee = null;
        throttle_handler = null;
    }
}

export {init_marques, desinit_marques}